<template>
  <div>
    <!-- edit route modal -->
    <modal name="edit-route-modal" height="auto" shiftX="0.95">
      <route-edit
        @cancelClicked="editRouteCancelClicked"
        @saveClicked="editRouteSaveClicked"
        :route="selectedRoute"
        :routeGeneral="routeGeneral"
        :routeActual="routeActual"
        :title="
          selectedRoute.vehicleModel +
          ' ' +
          new Date(selectedRoute.startByGps).toLocaleTimeString('sr-latn-cs') +
          ' - ' +
          new Date(selectedRoute.endByGps).toLocaleTimeString('sr-latn-cs')
        "
      >
      </route-edit>
    </modal>

    <!--Title-->
    <div class="content">
      <h2 class="subtitle">Detaljan pregled teretnih vozila</h2>
      <p v-if="selectedVehicle">{{ selectedVehicle.vehicleId }}</p>
    </div>

    <!-- Izaberi datum -->
    <div class="tabs is-centered is-medium">
      <ul>
        <li :class="{ 'is-active': true }">
          <a>Izaberi datum</a>
        </li>
      </ul>
    </div>

    <!-- Time Span -->
    <div class="content">
      <date-picker
        v-model="time3"
        @input="dateChosen"
        type="date"
      ></date-picker>
    </div>

    <!-- lista svih ruta teretnih vozila za izabrani dan -->
    <div v-if="today">
      <p>Lista svih ruta za izabrani datum</p>
      <route-list-table
        :data="routeLogsAll"
        @rowClicked="routeListTableRowClicked"
      ></route-list-table>
    </div>

    <!-- Izaberi vozilo -->
    <div v-if="today">
      <div class="tabs is-centered is-medium no-print">
        <ul>
          <li :class="{ 'is-active': true }">
            <a>Detalji teretnog vozila</a>
          </li>
        </ul>
      </div>

      <!-- vozilo -->
      <div slot="content">
        <div>
          <div class="field">
            <label class="label no-print">Vozilo</label>
            <div class="control">
              <vue-select
                class="has-background-info-light"
                @option:selected="vehicleSelected"
                type="text"
                label="name"
                :clearable="false"
                :options="vehicles"
                v-model="selectedVehicle"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Vehicle info -->
    <div v-if="selectedVehicleFull.vehicleId">
      <vehicle-info
        :licensePlate="selectedVehicleFull.licansePlate"
        :Model="selectedVehicleFull.model"
        :vehicleId="selectedVehicleFull.vehicleId"
        :employeeId="selectedVehicleFull.employeeId"
      />
    </div>

    <!-- GPS Access List -->
    <div v-if="selectedVehicleFull.vehicleId">
      <gps-access-list
        @gpsDataLoaded="gpsAccessListDataLoaded"
        @tableCellClcked="tableCellClcked"
        :today="today"
        :tomorrow="tomorrow"
        :vehicle="selectedVehicleFull"
      ></gps-access-list>
    </div>

    <!-- Route Logs -->
    <div v-if="selectedVehicleFull.vehicleId">
      <route-list
        :today="today"
        :tomorrow="tomorrow"
        :vehicle="selectedVehicleFull"
      >
      </route-list>
    </div>

    <!-- GPS Map -->
    <div v-if="selectedVehicleFull.vehicleId">
      <gps-map
        :polygons="polygonArray"
        :gpsAccessLists="gpsAccessListsArray"
        :routeGeneral="gpsRoute"
        :routeHighlighted="gpsRouteHighlighted"
      />
    </div>
  </div>
</template>

<script>
import RouteList from "../parts/RouteList.vue";
import GpsAccessList from "../parts/GpsAccessList.vue";
import GpsMap from "../parts/GpsMap.vue";
import VehicleInfo from "../parts/VehicleInfo.vue";
import DatePicker from "vue2-datepicker";
import reportService from "../../services/report.service";
import RouteListTable from "../parts/RouteListTable.vue";
import RouteEdit from "../parts/RouteEdit.vue";

export default {
  name: "VehicleDetails",

  components: {
    GpsAccessList,
    GpsMap,
    VehicleInfo,
    RouteList,
    DatePicker,
    RouteListTable,
    RouteEdit,
  },

  data() {
    return {
      today: null,
      tomorrow: null,
      vehicles: [],
      vehiclesFull: [],
      selectedVehicle: {},
      selectedVehicleFull: {},
      selectedRoute: {},
      routeGeneral: [],
      routeActual: [],
      time3: new Date(),
      polygonArray: [],
      gpsAccessListsArray: [],
      gpsRoute: [],
      gpsRouteHighlighted: [],
      routeLogsAll: [],
    };
  },

  async mounted() {
    // load query params if any
    // date param
    console.log(this.$route.query);
    const theDate = this.$route.query.date;
    if (theDate !== "undefined") {
      this.time3 = new Date(theDate);
    } else {
      this.time3 = new Date();
    }

    // Get freight vehicles
    let { data, error } = await reportService.GetFreightVehicles();

    this.vehiclesFull = data;
    console.log(error);

    // vehicle select box
    data.forEach((vehicle) => {
      this.vehicles.push({
        id: vehicle.vehicleId,
        name: vehicle.model,
      });
    });

    // vehicleId param
    const theVehicleId = this.$route.query.vehicleId;

    if (theVehicleId !== undefined) {
      this.selectedVehicle = data.find(
        (v) => (v.vehicleId = theVehicleId)
      ).theVehicleId;
    }

    // this.dateChosen(this.time3);
    // this.getDepartments();
  },

  methods: {
    dateChosen(date) {
      this.resetUi();
      console.log(this.time3);
      this.today = date;
      console.log("dateChosen");
      console.log(this.today);

      let nextDay1 = new Date(this.today);
      nextDay1.setDate(this.today.getDate() + 1);
      this.tomorrow = nextDay1;
      console.log(this.tomorrow);
      this.today.setHours(0, 0, 0, 0);
      this.tomorrow.setHours(0, 0, 0, 0);

      this.getFreightVehiclesRoutes();
    },

    async getFreightVehiclesRoutes() {
      console.log("Paja");

      this.routeLogsAll = (
        await reportService.GetRouteLogsForFreightVehiclesByStartDateAndEndDate(
          this.today,
          this.tomorrow
        )
      ).data;
    },

    vehicleSelected(vehicle) {
      this.selectedVehicleFull = this.vehiclesFull.find(
        (v) => v.vehicleId === vehicle.id
      );
    },

    resetUi() {
      this.selectedVehicle = {};
      this.selectedVehicleFull = {};
    },

    resetVehicleData() {
      this.isLo;
    },

    async gpsAccessListDataLoaded({ accessGpsList, polygon, vehicle }) {
      console.log("Loaded!!");

      // push this data to the map
      this.polygonArray = [];
      this.polygonArray.push(polygon);
      // this.gpsAccessListsArray = [];
      console.log(accessGpsList);
      // this.gpsAccessListsArray.push(accessGpsList);

      // load vehicle points for this vehicle
      const vehicleId = vehicle.vehicleId;
      console.log(vehicleId);
      // const gpsData = (
      //   await reportService.GetGpsMontenegroDataByIdAndStartDateAndEndDate(
      //     vehicleId,
      //     this.today,
      //     this.tomorrow
      //   )
      // ).data;

      const gpsData = (
        await reportService.GetSatworkDataByIdAndStartDateAndEndDate(
          vehicleId,
          this.today,
          this.tomorrow
        )
      ).data;

      console.log("gps data!");
      console.log(gpsData);

      // Iz ovih podataka izvući rutu
      this.gpsRoute = gpsData.route;
    },

    async routeListTableRowClicked(data) {
      console.log("event");
      this.selectedRoute = data;
      console.log(this.selectedRoute.vehicleId);
      console.log(data);

      // Iz ovih podataka izvući rutu
      this.selectedRoute.driverId = data.driverId;
      this.selectedRoute.codriverId = data.codriverId;
      this.selectedRoute.routeCardId = data.tourByCard;

      this.$modal.show("edit-route-modal");

      // find gpsData
      // const gpsData = (
      //   await reportService.GetGpsMontenegroDataByIdAndStartDateStringAndEndDateString(
      //     data.vehicleId,
      //     data.startByGps,
      //     data.endByGps
      //   )
      // ).data;

      // const gpsDataFull = (
      //   await reportService.GetGpsMontenegroDataByIdAndStartDateAndEndDate(
      //     data.vehicleId,
      //     this.today,
      //     this.tomorrow
      //   )
      // ).data;

      const gpsData = (
        await reportService.GetSatworkDataByIdAndStartDateStringAndEndDateString(
          data.vehicleId,
          data.startByGps,
          data.endByGps
        )
      ).data;

      const gpsDataFull = (
        await reportService.GetSatworkDataByIdAndStartDateAndEndDate(
          data.vehicleId,
          this.today,
          this.tomorrow
        )
      ).data;

      console.log("gps data!");
      console.log(gpsData);
      console.log(gpsDataFull);

      // Iz ovih podataka izvući rutu
      this.routeActual = gpsData.route;
      this.routeGeneral = gpsDataFull.route;
    },

    async tableCellClcked(data) {
      console.log(data);
      this.gpsRouteHighlighted = [];
      this.gpsRouteHighlighted.push(
        [data.insideLatitude, data.insideLongitude],
        [data.outsideLatitude, data.outsideLongitude]
      );
    },

    async editRouteSaveClicked(data) {
      console.log(data);
      let result = await reportService.EditRouteLog(data);
      this.$modal.hide("edit-route-modal");

      // change values locally
      console.log(result);
      this.dateChosen(this.today);
    },

    editRouteCancelClicked(data) {
      console.log(data);
      this.$modal.hide("edit-route-modal");
    },
  },
};
</script>
